module.exports = __webpack_public_path__ + "static/img/Light_Snow.84256949.png";